<template>
  <v-img :src="imgComputed" height="100vh">
    <v-btn large rounded depressed to="/inicio" class="float-btn">
      <v-icon left>mdi-chevron-left</v-icon>
      Regresar a inicio
    </v-btn>
  </v-img>
</template>
<style>
.float-btn {
  position: absolute;
  bottom: 6rem;
  left: 1rem;
  z-index: 100;
}

@media (min-width: 720px) {
  .float-btn {
    position: absolute;
    bottom: 18rem;
    left: 10rem;
  }
}
</style>
<script>
import { mapState } from "vuex";
export default {
  data: () => ({}),
  mounted() {},
  computed: {
    ...mapState({
      campus: (state) => state.cities.campus,
      city_options: (state) => state.cities.city_options,
      city_selected: (state) => state.cities.city_selected,
      cities: (state) => state.cities.cities,
      vida: (state) => state.cities.vida,
      link_location: (state) => state.cities.link_location,
      link_information: (state) => state.cities.link_information,
    }),
    imgComputed() {
      if (this.$vuetify.breakpoint.mdAndUp)
        return "/imagenes/gracias/contacta.jpg";

      return "/imagenes/gracias/contacta-ver.jpg";
    },
  },
  methods: {},
};
</script>